<template>
  <div class="has-background-white">
    <div class="notification is-warning is-marginless">
      <p class="is-uppercase is-size-7">
        SUR SON ESPACE ACQUÉREUR, VOTRE CLIENT VISUALISE TOUS LES POSTS DU PROGRAMME.
      </p>
      <p class="is-uppercase is-size-7">
        VOUS POUVEZ ÉGALEMENT CRÉER DES POSTS SPÉCIFIQUES QU’IL SERA LE SEUL A VOIR. LES EVENEMENTS SERONT NOTIFIÉS AUTOMATIQUEMENT AUX ACQUÉREURS
      </p>
    </div>
    <button
      v-if="orderedTimeline.length"
      class="page-header-btn button is-dark is-fullwidth is-radiusless"
      @click="openModalEvent()">
      <span>CRÉER UN NOUVEAU POST</span>
    </button>
    <div
      v-if="orderedTimeline.length"
      class="is-border has-background-white">
      <div class="column is-padding-right is-padding-left is-padding-bottom is-paddingless-top">
        <div class="timeline is-centered">
          <template v-for="(event, index) in orderedTimeline">
            <time-line-event
              :key="index"
              :id="advPk"
              :from="'reservations'"
              :event="event"
              @sliceEvent="sliceEvent"></time-line-event>
          </template>
        </div>
      </div>
    </div>
    <div
      v-else
      class="is-margin is-border is-padding">
      <div class="columns">
        <div class="column is-6 has-text-centered">
          <img
            src="/img/Groupe-14876.svg"
            alt="">
        </div>
        <div class="column is-6">
          <div class="title is-2 has-text-weight-medium is-margin-bottom-small">
            Créez votre premier post pour communiquer avec vos acquéreurs
          </div>
          <div class="">
            Informer vos clients sur l’actualité de votre programme
          </div>
          <div
            class="has-background-dark is-w64p is-margin-top-small"
            style="height: 2px;"></div>
          <p class="is-size-6 is-padding-top-small">
            Vos clients sont en attente d’information en rapport avec leur projet de logement. En quelques clic postez photos et documents qui leur sont destinés. Tous les acquéreurs seront automatiquement notifiés par mail.
          </p>
          <b class="is-size-6">Vous communiquez plus, vos client aiment !</b>
          <div class="is-margin-top">
            <a
              @click="openModalEvent()"
              type="button"
              class="button is-success is-minW260p">
              CRÉER VOTRE PREMIER POST
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isAdmin && isPromoteur"
      class="has-background-white is-border-top is-margin-top-xsmall">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaires</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <!-- <div v-if="!openWysi && comment" @click="openWysiwyg" class="vadDiscussion is-border-top"> -->
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="isAdmin && comment"
              v-html="comment"></div>
            <!-- <div class="content" v-else>Aucun commentaire</div> -->
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <!-- :disabled="loadComment && !comment"> -->
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <!-- <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false; comment = adv.comment"> -->
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Adv, Error } from '@/mixins'
import { orderBy } from 'lodash'

export default {
  name: 'AdvBuyerSpaceTimeline',
  components: {
    TimeLineEvent: () => import('../utils/TimeLineEvent')
  },
  mixins: [Adv, Error],
  props: {
    timeline: {
      type: Array
    }
  },
  computed: {
    /**
       * return time line ordered by date
       * @returns {array}
       */
    orderedTimeline () {
      return orderBy(this.timeline, x => {
        return x.date
      }, 'desc')
    }
  },
  watch: {
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'EVENT_MODAL') {
          if (params.id === this.advPk) {
            let idx = this.timeline.findIndex(x => {
              return x.pk === results.pk
            })
            this.$emit('updateTimeline', idx, results)
          }
        }
      }
    }
  },
  methods: {
    sliceEvent (pk) {
      this.$emit('sliceEvent', pk)
    },
    /**
       * open event modal
       */
    openModalEvent () {
      let params = {
        id: this.advPk,
        from: 'reservations'
      }
      this.$store.commit('setModal', { mode: 'EVENT_MODAL', params })
    }
  }
}
</script>
